import React from 'react';
import { Hotel } from 'lucide-react';
import { addDaysToLADateKey } from '../../utils/laDateUtils';
import '../css/AccommodationSection.css';

const formatKey = (key) => {
  if (!key) return 'N/A';
  const [y, m, d] = key.split('-');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${d}-${months[Number(m) - 1]}-${y}`;
};

/** RoomUnit.room_label for display: digits-only → "Room N"; already "Room …" unchanged; else as-is. */
const formatDisplayUnit = (raw) => {
  const s = String(raw ?? '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!s) return null;
  if (/^room\b/i.test(s)) return s;
  if (/^\d+$/.test(s)) return `Room ${s}`;
  return s;
};

const AccommodationSection = ({ bookingGroups }) => {
  const rows = Array.isArray(bookingGroups) ? bookingGroups : [];
  const rowCount = rows.length;

  return (
    <section
      className="accommodation-section accommodation-section--panel"
      aria-labelledby="accommodation-section-title"
    >
      <header className="accommodation-section__header">
        <div className="accommodation-section__title-row">
          <div className="accommodation-section__title-icon" aria-hidden>
            <Hotel size={20} strokeWidth={2.2} />
          </div>
          <h2 id="accommodation-section-title" className="accommodation-section__title">
            Accommodation details
          </h2>
        </div>
      </header>
      <div className="accommodation-section__body">
      {!rowCount ? (
        <p className="accommodation-section__empty">No accommodation bookings found.</p>
      ) : (
        <div className="accommodation-section-table-wrap table-responsive">
          <table className="table table-sm accommodation-section__table mb-0">
            <thead>
              <tr>
                <th scope="col">Hotel</th>
                <th scope="col">Unit</th>
                <th scope="col">Room type</th>
                <th scope="col">Check-in</th>
                <th scope="col">Check-out</th>
                <th scope="col" className="text-end text-nowrap">
                  Nights
                </th>
                <th scope="col">Allocation</th>
                <th scope="col" className="text-end text-nowrap">
                  $ / night
                </th>
                <th scope="col" className="text-end text-nowrap">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((g, i) => {
                const nightsNum = Number(g.nights);
                const nightsSafe = Number.isFinite(nightsNum) && nightsNum >= 0 ? nightsNum : null;
                const total = (nightsSafe ?? 0) * (Number(g.price) || 0);
                const unitDisplay = formatDisplayUnit(g.room_label);
                const typeStr = String(g.room_type ?? '')
                  .replace(/\s+/g, ' ')
                  .trim();
                return (
                  <tr
                    key={`${g.from_date}-${g.to_date}-${g.hotel_name}-${g.room_label}-${i}`}
                  >
                    <td>{g.hotel_name || '—'}</td>
                    <td className="accommodation-section__table-strong">{unitDisplay ?? '—'}</td>
                    <td className="accommodation-section__table-muted">{typeStr || '—'}</td>
                    <td className="text-nowrap">{formatKey(g.from_date)}</td>
                    <td className="text-nowrap">{formatKey(addDaysToLADateKey(g.to_date))}</td>
                    <td className="text-end">{nightsSafe === null ? '—' : nightsSafe}</td>
                    <td>{g.allocation_type || 'N/A'}</td>
                    <td className="text-end text-nowrap">
                      ${Number(g.price || 0).toLocaleString()}
                    </td>
                    <td className="text-end text-nowrap accommodation-section__table-total">
                      ${total.toLocaleString()}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      </div>
    </section>
  );
};

export default AccommodationSection;
